function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-strategie375"
}, /*#__PURE__*/React.createElement("rect", {
  width: 375,
  height: 250
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "strategie375",
  clipPath: "url(#clip-strategie375)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_3710",
  "data-name": "Gruppe 3710"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_3575",
  transform: "translate(-1013.025 -1582.141)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_1889",
  transform: "translate(969.074 1569.051)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_1239"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_1238",
  transform: "translate(1.338)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_984",
  d: "M183.5,57.5c45.1-26,102.5-11.1,128.2,33.4s10,101.7-35.2,127.7",
  fill: "#002b47"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_87",
  cx: 53.1,
  cy: 93,
  rx: 53.1,
  ry: 93,
  transform: "matrix(0.866, -0.5, 0.5, 0.866, 137.516, 84.101)",
  fill: "#33556c",
  stroke: "#009fe3",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_985",
  d: "M277.5,111.5C251.8,67,210.4,42.8,185,57.5h0c-45.1,26-60.8,83.2-35.2,127.7s83.1,59.4,128.2,33.4h0C303.4,204,303.2,156,277.5,111.5Z",
  fill: "#002b47"
})))), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_761",
  "data-name": "Rechteck 761",
  width: 375,
  height: 250,
  fill: "none"
})));

function SvgStrategie375(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    height: 250,
    viewBox: "0 0 375 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategie375);
export default __webpack_public_path__ + "static/media/strategie375.5c457fe2.svg";
export { ForwardRef as ReactComponent };